const AboutSection = () => {
  const strengths = [
    { icon: "ri-award-line", title: "KS 품질 인증", desc: "국가표준 KS F 4419 인증 획득" },
    { icon: "ri-tools-line", title: "직접 생산", desc: "충북 음성 공장 직접 생산" },
    { icon: "ri-map-pin-2-line", title: "전국 납품", desc: "전국 신속 납품 서비스" },
    { icon: "ri-team-line", title: "기술 지원", desc: "현장 맞춤 기술 자문 제공" }
  ];

  return (
    <section id="about" className="py-14 sm:py-24" style={{ backgroundColor: "#f9f9f7" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Image - 모바일에서 높이 줄임 */}
          <div className="relative">
            <div className="w-full h-52 sm:h-80 lg:h-[500px] rounded-xl sm:rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/836157e4b911c723a60bdc023d0f92e1/296a977d62c357ca4094f10862e5b735.jpeg"
                alt="삼성콘크리트 생산 공장"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-2 sm:-bottom-6 sm:-right-6 bg-orange-500 text-white rounded-xl sm:rounded-2xl p-4 sm:p-6">
              <div className="text-2xl sm:text-4xl font-black">1990s</div>
              <div className="text-xs sm:text-sm font-semibold opacity-80 mt-0.5">설립 이래 기술 축적</div>
            </div>
          </div>

          {/* Content */}
          <div className="mt-4 sm:mt-0">
            <span className="text-orange-500 text-xs sm:text-sm font-bold tracking-widest uppercase block mb-3">
              — ABOUT US
            </span>
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-black text-gray-900 leading-tight mb-4">
              신뢰할 수 있는<br />
              <span className="text-orange-500">보강토 전문기업</span>
            </h2>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6">
              삼성콘크리트(주)는 충청북도 음성군에 위치한 블럭식 보강토 옹벽 시스템 전문 제조기업으로,
              30년 이상의 기술력을 바탕으로 다양한 현장 환경에 최적화된 제품을 직접 설계·제조합니다.
            </p>

            {/* Strengths Grid */}
            <div className="grid grid-cols-2 gap-2 sm:gap-4">
              {strengths.map((item) => (
                <div key={item.title} className="bg-white rounded-xl p-3 sm:p-4 flex gap-2 sm:gap-3">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-orange-50 rounded-lg shrink-0">
                    <i className={`${item.icon} text-orange-500 text-base sm:text-lg`}></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-xs sm:text-sm">{item.title}</div>
                    <div className="text-gray-500 text-xs leading-relaxed mt-0.5">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
